import React from "react";
import { getStatusBarHeight } from "react-native-status-bar-height";
// import {Constants} from 'react-native-unimodules';
import { StyleSheet, SafeAreaView, View, Dimensions } from "react-native";
import colors from "../config/colors";

function Screen({ children, style }) {
  return (
    <SafeAreaView style={[styles.screen, style]}>
      <View style={[styles.view, style]}>{children}</View>
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  screen: {
    paddingTop: getStatusBarHeight(true),
    flex: 1,
    width: Dimensions.get("window").width,
    height: Dimensions.get("window").height - 64,
    backgroundColor: colors.white,
    alignItems: "center",
    position: "absolute",
  },
  view: {
    flex: 1,
    width: 1 * Dimensions.get("window").width,
    height: 1 * Dimensions.get("window").height,
  },
});

export default Screen;
